module.exports = __webpack_public_path__ + "static/media/left.05d660aa.svg";